import React, { useContext, useCallback } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { IUsersContext, UsersContext } from '../../usersState/usersContext';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } = useContext<IUsersContext>(UsersContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteUser"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteUserSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingUser"
			/>
		</div>
	);
};

export default ModalWindows;
